import { render } from "./NewApplications.vue?vue&type=template&id=6f3d86f6&scoped=true"
import script from "./NewApplications.vue?vue&type=script&lang=js"
export * from "./NewApplications.vue?vue&type=script&lang=js"

import "./NewApplications.vue?vue&type=style&index=0&id=6f3d86f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3d86f6"]])

export default __exports__